export enum ModuleEnum {
	ESUS_APS = 1,
	SINTEGRADA = 2,
}
